export const ProductListingFilterStyle = {
  DEFAULT: 'DEFAULT',
  GRID: 'GRID',
  SWATCH: 'SWATCH',
  SWATCH_GRID: 'SWATCH_GRID',
  TAGS_GRID: 'TAGS_GRID',
};
